/**
 * @generated SignedSource<<18067f7969c8462eca5bfe1209c1261e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandDashboardJobsQuery$variables = {
  brandId?: string | null;
};
export type InternBrandDashboardJobsQuery$data = {
  readonly internJobHealthMetrics: {
    readonly " $fragmentSpreads": FragmentRefs<"InternJobsHealthCard_metrics">;
  };
};
export type InternBrandDashboardJobsQuery = {
  response: InternBrandDashboardJobsQuery$data;
  variables: InternBrandDashboardJobsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "brandId",
    "variableName": "brandId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandDashboardJobsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "JobHealthMetrics",
        "kind": "LinkedField",
        "name": "internJobHealthMetrics",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternJobsHealthCard_metrics"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandDashboardJobsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "JobHealthMetrics",
        "kind": "LinkedField",
        "name": "internJobHealthMetrics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalJobs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "successCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failureCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "runningCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retryCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "successRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avgDurationMs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jobsLastHour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failuresLastHour",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "00d8d78a178eb07be57fffa612e0d33e",
    "id": null,
    "metadata": {},
    "name": "InternBrandDashboardJobsQuery",
    "operationKind": "query",
    "text": "query InternBrandDashboardJobsQuery(\n  $brandId: String\n) {\n  internJobHealthMetrics(brandId: $brandId) {\n    ...InternJobsHealthCard_metrics\n  }\n}\n\nfragment InternJobsHealthCard_metrics on JobHealthMetrics {\n  totalJobs\n  successCount\n  failureCount\n  runningCount\n  retryCount\n  successRate\n  avgDurationMs\n  jobsLastHour\n  failuresLastHour\n}\n"
  }
};
})();

(node as any).hash = "d63c83d9097ce205992749e1b4fc768c";

export default node;
